export default "__VITE_ASSET__QWKBKb_6__"